/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */

// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const GeneratingContainer: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div({
	display: 'flex',
	height: '92px',
	boxSizing: 'border-box',
	paddingTop: token('space.300'),
	paddingRight: token('space.300'),
	paddingBottom: '0px',
	paddingLeft: token('space.300'),
});
